import { FC, useState } from "react"
import Toggle from "@/components/shared/Toggle"
import { TestId } from "@/constants/globals"
import { Token } from "@/types/index"

const LocationToggle: FC = () => {
   const [activeToggle, setActiveToggle] = useState<boolean>(
      () =>
         (localStorage.getItem(Token.LOCATION_VISIBILITY) ?? "true") === "true"
   )

   const onChange = (): void => {
      const nextValue = !activeToggle
      setActiveToggle(nextValue)
      localStorage.setItem(Token.LOCATION_VISIBILITY, String(nextValue))
   }

   return (
      <div className="preferences__section">
         <Toggle
            label="Display Location"
            value={activeToggle}
            onChange={onChange}
            id="display-location-toggle"
            testId={TestId.DISPLAY_LOCATION_TOGGLE}
         />
         <div className="preferences__section-subtitle">
            Choose whether to display location or not
         </div>
      </div>
   )
}

export default LocationToggle
